import { Controller } from "@hotwired/stimulus"
import SlimSelect from "slim-select"

export default class extends Controller {
  static values = { 
    placeholder: String,
    multiple: Boolean
  }

  connect() {
    if (this.element.classList.contains('ss-initialized')) return
    
    this.element.classList.add('ss-initialized')
    
    // Immediately hide native styling
    this.element.style.appearance = 'none'
    this.element.style.webkitAppearance = 'none'
    this.element.style.mozAppearance = 'none'
    this.element.style.backgroundImage = 'none'
    
    // Check if we're in a modal for content location
    const isInModal = this.element.closest('dialog') || this.element.closest('.modal')
    
    const config = {
      select: this.element,
      settings: {
        showSearch: this.element.multiple ? false : true,
        contentLocation: isInModal ? isInModal : document.body,
        contentPosition: 'absolute'
      }
    }

    // Ensure dropdown appears above modals
    config.events = {
      ...config.events,
      afterInit: () => {
        // Completely hide original select after SlimSelect is ready
        this.element.style.display = 'none'
        this.element.style.opacity = '0'
        this.element.style.position = 'absolute'
        this.element.style.left = '-9999px'
      },
      afterOpen: () => {
        // Find the dropdown content that belongs to this specific select
        // We need to find the content associated with this particular SlimSelect instance
        setTimeout(() => {
          const allContents = document.querySelectorAll('.ss-content.ss-open')
          
          // Apply styling to all open dropdowns to ensure consistency
          allContents.forEach(content => {
            // Set proper DaisyUI background and styling
            content.style.backgroundColor = 'hsl(var(--b1))'
            content.style.border = '1px solid hsl(var(--bc) / 0.2)'
            content.style.borderRadius = '0.5rem'
            content.style.boxShadow = '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)'
            
            // For modals, ensure high z-index
            if (isInModal) {
              content.style.zIndex = '10001'  // Just above DaisyUI modal backdrop
            }
          })
        }, 10) // Small delay to ensure DOM is ready
      }
    }

    // Configure placeholder text - fix the data attribute reading
    if (this.hasPlaceholderValue) {
      config.placeholder = this.placeholderValue
    } else if (this.element.multiple) {
      config.placeholder = 'Select options...'
    }

    // Configure for multiselect
    if (this.element.multiple) {
      config.allowDeselect = true
      config.closeOnSelect = false
    }

    // Only add form submission if there's a form and it's not multiselect
    if (this.element.form && !this.element.multiple) {
      config.events = {
        afterChange: () => {
          this.element.form.requestSubmit()
        }
      }
    }

    this.select = new SlimSelect(config)
  }

  disconnect() {
    if (this.select) {
      this.element.classList.remove('ss-initialized')
      this.select.destroy()
    }
  }
} 